function CarouselItem(_type, _index, _src, _hashtag){
  this.type = _type;
  this.index = _index;
  this.src = _src;
  this.hashtag = _hashtag;
}

export default CarouselItem;
